<template>
  <div class="learningRecord">
    <!-- 筛选学习时间 -->
    <div class="timeNav">
      <div class="timeStr">学习时间</div>
      <div
        :class="[
          'timeItem',
          'cp',
          item.id === timeNavIndex ? 'timeIsSelected' : '',
        ]"
        v-for="item in timeNavList"
        :key="item.id"
        @click="changeTimeIndex(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 筛选学段 -->
    <div class="timeNav">
      <div class="timeStr">所属年级</div>
      <div
        :class="[
          'timeItem',
          'cp',
          item.id === classLevelId ? 'timeIsSelected' : '',
        ]"
        v-for="item in sectionList"
        :key="item.id"
        @click="changeSection(item.id)"
      >
        {{ item.title }}
      </div>
    </div>
    <!-- 卡片列表 -->
    <div class="cardList">
      <div
        class="cardItem cp"
        v-for="item in learningRecordList"
        :key="item.recordId"
        @click="goLookPPT(item.slidesId)"
      >
        <img :src="imagePath.lrList" alt="" class="logo" />
        <span class="classLevelName">{{ item.classLevelName }}</span>
        <div class="cont">
          <div>
            <div class="title">{{ item.slidesName }}</div>
            <div class="updateTime">
              <img :src="imagePath.updateTime" alt="" />
              {{ item.createTime }}
            </div>
          </div>
          <img
            class="close cp"
            :src="imagePath.closeBtn"
            alt=""
            @click.stop="deleteOneBrowserHistory(item.recordId)"
          />
        </div>
      </div>
      <div v-if="learningRecordList.length === 0">暂无学习记录</div>
    </div>
    <div class="listPagination">
      <a-pagination
        class="pagination"
        v-model="queryParams.page"
        align="right"
        show-size-changer
        :total="queryParams.total"
        :show-total="(total) => `共${total}个`"
        :page-size.sync="queryParams.pageSize"
        :default-current="1"
        @change="onChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import { mapState } from "vuex";
import { queryBrowsingRecords, deleteOneBrowserHistory } from "@/api/my";
import { getSectionList } from "@/api/my";

const timeNavList = [
  { id: 0, name: "最近7天" },
  { id: 1, name: "最近15天" },
  { id: 2, name: "最近30天" }
];
export default {
  name: "LearningRecord",
  data() {
    return {
      imagePath,
      timeNavList, // 时间筛选列表
      sectionList: [{ id: "", title: "全部" }], // 学段列表
      timeNavIndex: 0, // 时间索引
      // 分页参数
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      userId: "", // 用户id
      classLevelId: "", // 学段id
      learningRecordList: [] // 学习记录列表
    };
  },
  computed: {
    ...mapState({ userInfo: (state) => state.user.userInfo }),
    updateTime() {
      switch (this.timeNavIndex) {
        case 0:
          return this.dateFormat("YYYY-mm-dd HH:MM:SS", 7);
        case 1:
          return this.dateFormat("YYYY-mm-dd HH:MM:SS", 15);
        case 2:
          return this.dateFormat("YYYY-mm-dd HH:MM:SS", 30);
        default:
          return "";
      }
    }
  },
  created() {
    this.userId = this.userInfo.userId;
    this.getSection();
    this.queryBrowsingRecords();
  },
  updated() {
    // 改变分页样式 根据classNum存的数据而变化
    const color = "#66A8F5";
    // 页数序列
    const pagination = document.getElementsByClassName("ant-pagination-item");
    if (pagination.length > 0) {
      for (let i = 0; i < pagination.length; i++) {
        pagination[i].style.borderColor = color;
        pagination[i].style.backgroundColor = "#fff";
        pagination[i].getElementsByTagName("a")[0].style.color = color;
      }
    }
    // 被选中的页数序列
    const paginationActive = document.getElementsByClassName(
      "ant-pagination-item-active"
    );
    if (paginationActive.length > 0) {
      for (let i = 0; i < paginationActive.length; i++) {
        paginationActive[i].style.borderColor = color;
        paginationActive[i].style.backgroundColor = color;
        paginationActive[i].getElementsByTagName("a")[0].style.color = "#fff";
      }
    }
    // 左滑
    const paginationPrev = document
      .getElementsByClassName("ant-pagination-prev")[0]
      .getElementsByTagName("a")[0];
    paginationPrev.style.borderColor = color;
    paginationPrev.style.color = color;
    // 右滑
    const paginationNext = document
      .getElementsByClassName("ant-pagination-next")[0]
      .getElementsByTagName("a")[0];
    paginationNext.style.borderColor = color;
    paginationNext.style.color = color;
    // 被禁用的左右滑
    const paginationDisabled = document
      .getElementsByClassName("ant-pagination-disabled")[0]
      .getElementsByTagName("a")[0];
    paginationDisabled.style.borderColor = "#d9d9d9";
    paginationDisabled.style.color = "rgba(0, 0, 0, 0.25)";
    const paginationSelection = document.getElementsByClassName(
      "ant-select-selection"
    )[0];
    paginationSelection.style.borderColor = color;
    paginationSelection.style.color = color;
    // console.log(pagination, "paginationPrev");
  },
  methods: {
    // 跳转查看ppt
    goLookPPT(id) {
      this.$router.push({ path: "/lookPPT", query: { id: id }});
    },
    // 时间格式化 fmt时间格式 num几天前
    dateFormat(fmt, num) {
      const currentDate = new Date();
      const oldDate = currentDate.setDate(currentDate.getDate() - num);
      const date = new Date(oldDate);
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (const k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    // 页数改变
    onChange(page) {
      this.queryParams.page = page;
      this.queryBrowsingRecords();
    },
    // 每一页的条数改变
    onShowSizeChange(page, pageSize) {
      this.queryParams.page = page;
      this.queryParams.pageSize = pageSize;
      this.queryBrowsingRecords();
    },
    // 获取学段
    async getSection() {
      const { data, status,msg } = await getSectionList();
      if (status === 200) {
        const list = data.data;
        // console.log(list, "list");
        this.sectionList = this.sectionList.concat(list);
        // this.classLevelId = data.entityList[0].id;
        // console.log(this.sectionList, "sectionList");
      } else {
        this.$message.error(msg);
      }
    },
    // 删除学习记录
    async deleteOneBrowserHistory(id) {
      const { status, msg } = await deleteOneBrowserHistory(id);
      if (status === 200) {
        this.$message.success("删除成功");
        await this.queryBrowsingRecords();
      } else {
        this.$message.error(msg);
      }
    },
    // 查询学习记录
    async queryBrowsingRecords() {
      const params = {
        updateTime: this.updateTime,
        userId: this.userId,
        classLevelId: this.classLevelId,
        ...this.queryParams
      };
      const { data, status, msg } = await queryBrowsingRecords(params);
      if (status === 200) {
        this.learningRecordList = data.entityList;
        this.queryParams.total = data.total;
        if (data.pageSize !== 0) this.queryParams.pageSize = data.pageSize;
        this.queryParams.page = data.currentPage;
        // console.log(data, "queryBrowsingRecords");
      } else {
        this.$message.error(msg);
      }
    },
    // 切换学段
    changeSection(id) {
      this.classLevelId = id;
      this.queryBrowsingRecords();
    },
    // 切换时间
    changeTimeIndex(id) {
      this.timeNavIndex = id;
      this.queryBrowsingRecords();
    }
  }
};
</script>

<style lang="less" scoped>
.learningRecord {
  position: relative;
  height: 761px;

  .timeNav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 927px;

    .timeStr {
      margin-bottom: 30px;
      margin-right: 30px;
      color: #333333;
      font-size: 20px;
      font-weight: 600;
    }

    .timeItem {
      margin-bottom: 30px;
      margin-right: 10px;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      color: #666666;
      text-align: center;
      border-radius: 30px;
    }

    .timeItem:nth-child(9) {
      margin-left: 110px;
    }

    .timeIsSelected {
      background: #ddf4ff;
      color: #17affd;
    }
  }

  .cardList {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    width: 930px;
    // height: 480px;
    .cardItem {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      position: relative;
      margin-right: 70px;
      margin-bottom: 30px;
      width: 395px;
      height: 66px;
      background: #ffffff;
      border: 1px solid #c5ecff;
      border-radius: 15px;

      .logo {
        margin-left: -6px;
        width: 51px;
        height: 29px;
      }

      .classLevelName {
        position: absolute;
        top: 22px;
        left: 0;
        height: 12px;
        line-height: 12px;
        font-size: 12px;
        color: #666666;
        transform: scale(0.8);
      }

      .cont {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 10px;

        > div {
          .title {
            width: 310px;
            font-size: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .updateTime {
            font-size: 12px;

            img {
              width: 12px;
              height: 12px;
            }
          }
        }

        .close {
          display: none;
          margin-right: 20px;
          width: 16px;
        }
      }
    }

    .cardItem:hover {
      border: 0;
      box-shadow: 2px 6px 20px 4px rgba(2, 55, 92, 0.08);

      .close {
        display: block;
      }
    }
  }

  .listPagination {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
</style>
